/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  IconConfig,
  IconConfig$inboundSchema,
  IconConfig$Outbound,
  IconConfig$outboundSchema,
} from "./iconconfig.js";
import {
  Ref,
  Ref$inboundSchema,
  Ref$Outbound,
  Ref$outboundSchema,
} from "./ref.js";

/**
 * A mapping of icon names and variants to a enum values for a ref.
 */
export type IconRefMap = {
  /**
   * A map of keys to icon configurations
   */
  iconMap?: { [k: string]: IconConfig } | undefined;
  /**
   * A reference to a reading or setting.
   */
  ref?: Ref | undefined;
};

/** @internal */
export const IconRefMap$inboundSchema: z.ZodType<
  IconRefMap,
  z.ZodTypeDef,
  unknown
> = z.object({
  icon_map: types.optional(z.record(IconConfig$inboundSchema)),
  ref: types.optional(Ref$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "icon_map": "iconMap",
  });
});
/** @internal */
export type IconRefMap$Outbound = {
  icon_map?: { [k: string]: IconConfig$Outbound } | undefined;
  ref?: Ref$Outbound | undefined;
};

/** @internal */
export const IconRefMap$outboundSchema: z.ZodType<
  IconRefMap$Outbound,
  z.ZodTypeDef,
  IconRefMap
> = z.object({
  iconMap: z.record(IconConfig$outboundSchema).optional(),
  ref: Ref$outboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    iconMap: "icon_map",
  });
});

export function iconRefMapToJSON(iconRefMap: IconRefMap): string {
  return JSON.stringify(IconRefMap$outboundSchema.parse(iconRefMap));
}
export function iconRefMapFromJSON(
  jsonString: string,
): SafeParseResult<IconRefMap, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => IconRefMap$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'IconRefMap' from JSON`,
  );
}
